// TOP LEVEL IMPORTS
import gql from "graphql-tag";

export default gql`
  mutation uploadAdminDoc($args: UploadAdminDocParams!) {
    uploadAdminDoc(args: $args) {
      id
      filename
      mimetype
      url
    }
  }
`;
